// eslint-disable-next-line no-restricted-syntax
import { createRoot } from 'react-dom/client';
import { Route, RouterProvider, createBrowserRouter, createRoutesFromElements } from 'react-router-dom';
import initSentry from 'app/bootstrap/sentry';
import initHotjar from 'app/bootstrap/hotjar';
import { initMixpanel } from 'infrastructure/integrations/mixpanel';
import App from 'app/App';

initSentry();
initHotjar();
initMixpanel(process.env.REACT_APP_DAVINCI_FRONTEND_MIXPANEL_TOKEN);

// eslint-disable-next-line react/jsx-filename-extension
const router = createBrowserRouter(createRoutesFromElements(<Route path="*" element={<App />} />));

const root = createRoot(document.getElementById('root'));

root.render(<RouterProvider router={router} />);
